import { render, staticRenderFns } from "./CustomSwitch.vue?vue&type=template&id=f91ccd2e&scoped=true"
import script from "./CustomSwitch.vue?vue&type=script&lang=js"
export * from "./CustomSwitch.vue?vue&type=script&lang=js"
import style0 from "./CustomSwitch.vue?vue&type=style&index=0&id=f91ccd2e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91ccd2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f91ccd2e')) {
      api.createRecord('f91ccd2e', component.options)
    } else {
      api.reload('f91ccd2e', component.options)
    }
    module.hot.accept("./CustomSwitch.vue?vue&type=template&id=f91ccd2e&scoped=true", function () {
      api.rerender('f91ccd2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CustomSwitch.vue"
export default component.exports